import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import ScrollToHashElement from "./components/ScrollToHashElement";
import InPatients from "./components/InPatients";

// Lazy load heavy components
const About = React.lazy(() => import("./pages/About"));
const Doctor = React.lazy(() => import("./pages/Doctor"));
const Contact = React.lazy(() => import("./pages/Contact"));
const Specialties = React.lazy(() => import("./pages/Specialties"));
const Specialty = React.lazy(() => import("./pages/Specialty"));
const Procedures = React.lazy(() => import("./pages/Procedures"));
const InfraEquipment = React.lazy(() => import("./pages/InfraEquipment"));
const Patients = React.lazy(() => import("./pages/Patients"));
const Blog = React.lazy(() => import("./pages/Blog"));
const Gallary = React.lazy(() => import("./pages/Gallary"));
const Gynecology = React.lazy(() => import("./pages/GynecologicalProcesses"));
const Orthopaedic = React.lazy(() => import("./pages/OrthopadicProcedures"));
const BlogPage = React.lazy(() => import("./pages/BlogPage"));
const AdminPage = React.lazy(() => import("./pages/AdminPage"));


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToHashElement />
      <Suspense fallback={<div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>Loading...</div>}>
        <Routes>
          <Route path="/" element={<App />}>
            <Route index element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />

            <Route path="/doctor" element={<Doctor />} />
            <Route path="/doctor/:name" element={<Doctor />} />

            <Route path="/specialties" element={<Specialties />} />
            <Route path="/specialties/:name" element={<Specialty />} />

            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<Blog />} />

            <Route path="/procedures" element={<Procedures />} />
            <Route path="/procedures/orthopedics" element={<Orthopaedic />} />
            <Route path="/procedures/gynecology" element={<Gynecology />} />
            <Route path="/infra-equipment" element={<InfraEquipment />} />
            <Route path="/gallary" element={<Gallary />} />
            <Route path="/patients" element={<Patients />} />
            <Route path="/international-patients" element={<InPatients />} />
          </Route>

          <Route path="/admin/*" element={<AdminPage />} />
          <Route path="*" element={<NotFound />} />

        </Routes>
      </Suspense>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
